  (function ($) {
    // Use $ safely inside this function
    $(document).ready(function () {
      function updateSpeed1() {
        let speed;
        if ($(window).width() > 1920) {
          speed = 1.5;
        } else {
          speed = 1;
        }
        $('.marquee1').attr('data-speed', speed);
      }
      updateSpeed1();
      $(window).resize(function () {
        updateSpeed1();
      });

      function updateSpeed2() {
        let speed;
        if ($(window).width() > 1920) {
          speed = -1.5;
        } else {
          speed = -1;
        }
        $('.marquee2').attr('data-speed', speed);
      }
      updateSpeed2();
      $(window).resize(function () {
        updateSpeed2();
      });

      const marquees = document.querySelectorAll('div.marquee');
      marquees.forEach(function (element) {
        let tick = 1;
        let value = element.dataset.speed;
        element.innerHTML += element.innerHTML;
        element.innerHTML += element.innerHTML;
        const innerTags = element.querySelectorAll('ul.inner');
        innerTags.forEach((inner, index) => {
          inner.style.left = inner.offsetWidth * index + 'px';
        });
        const ticker = function () {
          tick += parseInt(value);
          innerTags.forEach((inner, index) => {
            let width = inner.offsetWidth;
            let normalizedMarqueeX = ((tick % width) + width) % width;
            let pos = width * (index - 1) + normalizedMarqueeX;

            inner.style.left = pos + 'px';
          });
          requestAnimationFrame(ticker);
        };
        ticker();
      });
    });
  })(jQuery);